<odx-content-box class="mobile-list-item" [class.expanded]="expanded">
  <div class="header-row">
    <button type="button" class="title-button" (click)="onToggle()" [attr.aria-expanded]="expanded">
      <span class="odx-title-6 title">{{ title }}</span>
    </button>

    <div class="actions" (click)="$event.stopPropagation()">
      <ng-content select="[mobileListActions]"></ng-content>
    </div>
  </div>

  <div class="mobile-list-body" [class.expanded]="expanded" [attr.aria-hidden]="!expanded" [attr.inert]="expanded ? null : ''">
    <div class="mobile-list-body-content">
      <ng-content select="[mobileListBody]"></ng-content>
    </div>
  </div>
</odx-content-box>
